<template>
  <div>
    <b-card title="Create New Invoice Information">
      <validation-observer ref="simpleRules">
        <form ref="form">
          <b-row>
            <b-col md="6">
              <b-form-group label="Company Name" label-for="company">
                <validation-provider
                  #default="{ errors }"
                  name="company"
                  rules="required"
                >
                  <b-form-select
                    class="form-control"
                    @change="getMerchant"
                    v-model="invoiceRequest.companyId"
                    :options="companies"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group label="Merchant Name" label-for="merchants">
                <validation-provider
                  #default="{ errors }"
                  name="merchants"
                  rules="required"
                >
                  <v-select
                    multiple
                    v-model="selectedMerchant"
                    :options="merchants"
                    label="text"
                  >
                    <template #option="option">
                      <span>{{ option.text }}</span>
                    </template>
                  </v-select>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col cols="6">
              <b-form-group label="Invoice period">
                <validation-provider
                  #default="{ errors }"
                  name="Invoice period"
                  rules="required"
                >
                  <flat-pickr
                    v-model="invoiceRequest.Invoice_period"
                    class="form-control"
                    :config="flatpickrConfig"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col
              cols="12"
              class="d-flex align-self-center d-flex justify-content-around"
            >
              <b-button @click="filterInvoice" variant="primary">
                <feather-icon icon="FileIcon" />&nbsp;Get Invoice
              </b-button>
              <b-button @click="filterInvoiceDetail" variant="primary">
                <feather-icon icon="FileTextIcon" />&nbsp;Get Invoice Detail
              </b-button>
            </b-col>
          </b-row>
        </form>
      </validation-observer>
    </b-card>
    <div v-if="invoiceDetailsFiltered === true">
      <b-row class="mb-1">
        <b-col class="d-flex justify-content-end">
          <section>
            <xlsx-workbook>
              <xlsx-sheet
                v-for="sheet in sheets"
                :key="sheet.name"
                :collection="sheet.data"
                :sheet-name="sheet.name"
              />
              <xlsx-download>
                <b-button variant="outline-primary" class="d-flex">
                  <feather-icon icon="DownloadCloudIcon" /> Export
                </b-button>
              </xlsx-download>
            </xlsx-workbook>
          </section>
        </b-col>
      </b-row>

      <div
        v-if="invoiceDetails.invoiceDetails"
        v-for="invoiceDetail in invoiceDetails.invoiceDetails"
        :key="invoiceDetail.merchantName"
      >
        <b-card :title="invoiceDetail.merchantName">
          <b-table
            striped
            :items="invoiceDetail.transactions"
            :fields="invoiceDetailfields"
            caption-top
          >
            <template v-slot:cell(No)="data"> {{ data.index + 1 }} </template>
            <template #custom-foot>
              <b-tr>
                <b-th colspan="3" class="text-center">Total:</b-th>
                <b-td>{{ invoiceDetail.totalTransactions }}</b-td>
                <b-td>{{ invoiceDetail.totalRevenue }}</b-td>
              </b-tr>
            </template>
          </b-table>
        </b-card>
      </div>

      <b-card title="Grand Total Summary">
        <table border="1">
          <thead>
            <tr>
              <th>
                <div
                  class="d-flex justify-content-center justify-content-start"
                ></div>
              </th>
              <th>
                <div
                  class="d-flex justify-content-center justify-content-start"
                >
                  <h5 class="font-weight-bolder m-1 text-dark">
                    Total Transaction Count
                  </h5>
                </div>
              </th>
              <th>
                <div
                  class="d-flex justify-content-center justify-content-start"
                >
                  <h5 class="font-weight-bolder m-1 text-dark">
                    Grand Collected Amount (ETB)
                  </h5>
                </div>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <div class="m-1">
                  <div class="d-flex justify-content-start">
                    <h5 class="font-weight-bolder text-dark">
                      Total Across Services
                    </h5>
                  </div>
                </div>
              </td>
              <td>
                <div class="d-flex m-1 justify-content-center">
                  <h5 class="font-weight-bolder text-dark">
                    {{ invoiceDetails.grandTotalTransactions }}
                  </h5>
                </div>
              </td>
              <td>
                <div class="d-flex m-1 justify-content-center">
                  <h5 class="font-weight-bolder text-dark">
                    {{ invoiceDetails.grandTotalRevenue }}
                  </h5>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </b-card>
    </div>
    <div v-if="invoiceFiltered === true">
      <b-row class="d-flex mb-1 justify-content-end">
        <b-col md="2">
          <b-button @click="downloadPDF" variant="outline-primary"
            >Export as PDF</b-button
          >
        </b-col>
        <b-col md="2">
          <b-button @click="downloadWord" variant="outline-primary"
            >Export as Word</b-button
          >
        </b-col>
      </b-row>
      <b-card>
        <div
          id="element-to-convert"
          class="popular d-flex fixed mt-4 mx-2 d-flex justify-content-center"
          align="center"
        >
          <div class="annual-plan" align="left">
            <div class="d-flex justify-content-end">
              <p class="font-weight-bolder text-dark">Invoice Number :</p>
              <p>&nbsp;{{ invoices.invoiceNumber }}</p>
            </div>
            <div class="d-flex justify-content-end">
              <p class="font-weight-bolder text-dark">Invoice Period :</p>
              <p>&nbsp;{{ invoices.invoice_Period }}</p>
            </div>
            <div class="d-flex justify-content-end">
              <p class="font-weight-bolder text-dark">Date :</p>
              <p>&nbsp;{{ invoices.invoiceDate }}</p>
            </div>

            <div class="d-flex justify-content-start">
              <p class="font-weight-bolder text-dark">Telephone :</p>
              <p>&nbsp;{{ invoices.invoice_Address.telephone }}</p>
            </div>
            <div class="d-flex justify-content-start">
              <p class="font-weight-bolder text-dark">P.o.Box :</p>
              <p>&nbsp;{{ invoices.invoice_Address.poBox }}</p>
            </div>
            <div class="d-flex justify-content-start">
              <p class="font-weight-bolder text-dark">Fax :</p>
              <p>&nbsp;{{ invoices.invoice_Address.fax }}</p>
            </div>
            <div class="d-flex justify-content-start">
              <p class="font-weight-bolder text-dark">Address :</p>
              <p>&nbsp;{{ invoices.invoice_Address.address }}</p>
            </div>
            <div class="table-responsive d-flex justify-content-center">
              <table border>
                <thead>
                  <tr>
                    <th>
                      <div
                        class="d-flex justify-content-center justify-content-start"
                      >
                        <h3 class="font-weight-bolder m-1 text-dark">
                          {{ invoices.company }}
                        </h3>
                      </div>
                    </th>
                    <th>
                      <div
                        class="d-flex justify-content-center justify-content-start"
                      >
                        <h3 class="font-weight-bolder m-1 text-dark">
                          Amount in ETB
                        </h3>
                      </div>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <div class="d-flex m-1 justify-content-start">
                        <h5 class="font-weight-bolder text-dark">
                          {{ invoices.bodyStatement }}
                        </h5>
                      </div>
                      <div class="m-1">
                        <b-table
                          striped
                          :items="invoices.transactions"
                          :fields="invoicefields"
                          :responsive="true"
                        >
                          <template #custom-foot>
                            <b-tr>
                              <b-th colspan="1" class="text-center">
                                Total Sum
                              </b-th>
                              <b-td>
                                <p class="font-weight-bolder">
                                  {{ invoices.totals.transactionCount }}
                                </p>
                              </b-td>
                              <b-td>
                                <p class="font-weight-bolder">
                                  {{ invoices.totals.totalCollectedAmount }}
                                </p>
                              </b-td>

                              <b-td>
                                <p class="font-weight-bolder">
                                  {{ invoices.totals.totalServiceFee }}
                                </p></b-td
                              >
                            </b-tr>
                            <b-tr>
                              <b-th colspan="3" class="text-right"
                                >Add 15% VAT</b-th
                              >
                              <b-td>
                                <p class="font-weight-bolder">
                                  {{ invoices.totals.vat }}
                                </p></b-td
                              >
                            </b-tr>
                            <b-tr>
                              <b-th colspan="3" class="text-right"
                                >Total Amount Including VAT</b-th
                              >
                              <b-td>
                                <p class="font-weight-bolder">
                                  {{ invoices.totals.totalServiceFeeWithVAT }}
                                </p></b-td
                              >
                            </b-tr>
                          </template>
                        </b-table>
                      </div>
                      <div class="d-flex m-1 justify-content-end">
                        <h6 class="text-dark">
                          {{ invoices.totals.serviceFeeInWords }}
                        </h6>
                      </div>

                      <div class="m-1">
                        <div class="d-flex justify-content-start">
                          <h5 class="font-weight-bolder text-dark">
                            <u>BANK ACCOUNT DETIALS</u>
                          </h5>
                        </div>
                        <div>
                          <span>Bank Name: </span>
                          <span class="text-dark" style="font-size: 1.125rem">
                            {{ invoices.bankDetails.bankName }}
                          </span>
                        </div>
                        <div>
                          <span>Beneficiary Name: </span>
                          <span class="text-dark" style="font-size: 1.125rem">
                            {{ invoices.bankDetails.beneficiaryName }}
                          </span>
                        </div>
                        <div>
                          <span>Account Number: </span>
                          <span class="text-dark" style="font-size: 1.125rem">
                            {{ invoices.bankDetails.accountNumber }}
                          </span>
                        </div>
                      </div>
                      <div class="m-1">
                        <div class="d-flex justify-content-center">
                          <h4 class="font-weight-bolder text-dark">
                            {{ invoices.signatory.name }}
                          </h4>
                        </div>
                        <div class="d-flex justify-content-center">
                          <h5 class="font-weight-bolder text-dark">
                            {{ invoices.signatory.position }}
                          </h5>
                        </div>
                      </div>
                      <div class="d-flex m-1 justify-content-start">
                        <p>
                          {{ invoices.footerNote }}
                        </p>
                      </div>
                    </td>
                    <td>
                      <div class="d-flex m-1 justify-content-center">
                        <h3 class="font-weight-bolder text-dark">
                          {{ invoices.totals.totalServiceFeeWithVAT }}
                        </h3>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </b-card>
    </div>
    <b-overlay :show="isLoading" no-wrap rounded="sm" />
  </div>
</template>

<script>
import {
  BTabs,
  BTab,
  BCard,
  BButton,
  BBadge,
  BPagination,
  BOverlay,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BFormDatepicker,
  BRow,
  BCol,
  BForm,
  BTable,
  BCardText,
  BFormCheckbox,
  BTr,
  BTd,
  BTh,
} from "bootstrap-vue";
import { VueGoodTable } from "vue-good-table";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "@validations";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import axios from "@axios";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import monthSelectPlugin from "flatpickr/dist/plugins/monthSelect";
import "flatpickr/dist/plugins/monthSelect/style.css";
import vSelect from "vue-select";
import XlsxSheet from "../../../../node_modules/vue-xlsx/dist/components/XlsxSheet";
import XlsxDownload from "../../../../node_modules/vue-xlsx/dist/components/XlsxDownload";
import XlsxWorkbook from "../../../../node_modules/vue-xlsx/dist/components/XlsxWorkbook";
import html2pdf from "html2pdf.js";
import htmlDocx from "html-docx-js/dist/html-docx";
import { saveAs } from "file-saver";

export default {
  components: {
    BTr,
    BTd,
    BTh,
    BTabs,
    BTab,
    BRow,
    BCol,
    BCard,
    VueGoodTable,
    BBadge,
    BButton,
    BOverlay,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BFormDatepicker,
    flatPickr,
    BForm,
    BTable,
    BCardText,
    BFormCheckbox,
    ValidationProvider,
    ValidationObserver,
    vSelect,
    XlsxWorkbook,
    XlsxSheet,
    XlsxDownload,
    html2pdf,
  },
  data() {
    const nowDate = new Date();
    return {
      number: 0,
      required,
      isLoading: true,
      invoiceFiltered: false,
      invoiceDetailsFiltered: false,
      companies: [],
      merchants: [],
      selectedMerchant: [],
      invoiceRequest: {
        companyId: null,
        merchant_ids: [],
        Invoice_period: "",
      },
      invoices: [],
      invoiceDetails: [],
      invoiceDetailfields: [
        "No",
        "paymentOption",
        "transactionDate",
        "transactionCount",
        "revenue",
      ],
      invoicefields: [
        "merchantName",
        "transactionCount",
        "totalAmountETB",
        "serviceFeeETB",
      ],
      sheets: [],
    };
  },
  computed: {
    flatpickrConfig() {
      return {
        maxDate: "today",
        plugins: [
          monthSelectPlugin({
            shorthand: true,
            dateFormat: "Y-m",
          }),
        ],
      };
    },
  },
  created() {
    this.getCompanies();
  },
  methods: {
    downloadPDF() {
      const element = document.getElementById("element-to-convert");
      const opt = {
        margin: 0.5,
        filename: `Invoice_${this.invoices.company}_${this.invoices.invoice_Period}.pdf`,
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: { scale: 2, useCORS: true },
        jsPDF: { unit: "in", format: "a4", orientation: "portrait" },
      };
      html2pdf().set(opt).from(element).save();
    },
    downloadWord() {
      // Get your card's HTML
      const element = document.getElementById("element-to-convert");
      const html = element.innerHTML;
      // Wrap in a basic HTML doc (with some minimal styling for better fidelity)
      const header =
        "<html><head><meta charset='utf-8'><style>body{font-family:sans-serif;}table{border-collapse:collapse;}th,td{border:1px solid #ccc; padding:5px;}</style></head><body>";
      const footer = "</body></html>";
      const fullHtml = header + html + footer;

      // Convert HTML to docx Blob
      const docxBlob = htmlDocx.asBlob(fullHtml);
      // Download
      saveAs(
        docxBlob,
        `${this.invoices.company}_${this.invoices.invoice_Period}.docx`
      );
    },
    getCompanies() {
      this.$http
        .get("/Merchant/api/V1.0/Merchants/GetAllCompanies")
        .then(async (res) => {
          await res.companies.map((c) =>
            this.companies.push({ value: c.id, text: c.name })
          );
          this.isLoading = false;
        })
        .catch((err) => {
          console.log(err);
          this.isLoading = false;
        });
    },
    getMerchant() {
      this.merchants = [];
      this.isLoading = true;
      this.$http
        .get(
          `/Invoice/api/V1.0/Invoice/GetAllMerchantsForCompany?companyId=${this.invoiceRequest.companyId}`
        )
        .then(async (res) => {
          await res.merchants.map((c) =>
            this.merchants.push({ value: c.id, text: c.name })
          );
          this.isLoading = false;
        })
        .catch((err) => {
          console.log(err);
          this.isLoading = false;
        });
    },
    filterInvoice() {
      this.invoiceRequest.merchant_ids = [];
      this.$refs.simpleRules.validate().then(async (success) => {
        if (success) {
          this.isLoading = true;
          this.selectedMerchant.map((m) => {
            this.invoiceRequest.merchant_ids.push(m.value);
          });
          axios
            .get(
              `/Invoice/api/V1.0/Invoice/GetInvoice?InvoiceDate=${this.invoiceRequest.Invoice_period}&CompanyId=${this.invoiceRequest.companyId}&MerchantIds=${this.invoiceRequest.merchant_ids}`
            )
            .then((res) => {
              this.invoiceDetailsFiltered = false;
              this.invoices = [];
              this.invoices = res.invoiceResponse;
              this.invoiceFiltered = true;
              this.isLoading = false;
            })
            .catch((res) => {
              console.log(res);
              this.isLoading = false;
              this.$toast({
                component: ToastificationContent,
                position: "top-right",
                props: {
                  title: "Error",
                  icon: "BellIcon",
                  variant: "danger",
                  text: `${res.data.message}`,
                },
              });
            });
        }
      });
    },
    filterInvoiceDetail() {
      this.invoiceRequest.merchant_ids = [];
      this.$refs.simpleRules.validate().then(async (success) => {
        if (success) {
          this.isLoading = true;
          this.selectedMerchant.map((m) => {
            this.invoiceRequest.merchant_ids.push(m.value);
          });

          axios
            .get(
              `/Invoice/api/V1.0/Invoice/GetInvoiceDetail?InvoiceDate=${this.invoiceRequest.Invoice_period}&CompanyId=${this.invoiceRequest.companyId}&MerchantIds=${this.invoiceRequest.merchant_ids}`
            )
            .then((res) => {
              this.invoiceFiltered = false;
              this.invoiceDetails = [];
              this.sheets = [];
              this.invoiceDetails = res;

              res.invoiceDetails.map((m) => {
                const sheetData = m.transactions.map((t) => {
                  return { ...t };
                });
                sheetData.push({
                  transactionDate: "Total",
                  transactionCount: m.totalTransactions,
                  revenue: m.totalRevenue,
                });
                this.sheets.push({
                  name: m.merchantName.slice(0, 31),
                  data: sheetData,
                });
              });
              this.invoiceDetailsFiltered = true;
              this.isLoading = false;
            })
            .catch((res) => {
              console.log(res);
              this.isLoading = false;
              this.$toast({
                component: ToastificationContent,
                position: "top-right",
                props: {
                  title: "Error",
                  icon: "BellIcon",
                  variant: "danger",
                  text: `${res.data.message}`,
                },
              });
            });
        }
      });
    },
    // Api call
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-good-table.scss";
</style>
<style lang="scss">
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>

<style lang="scss">
@import "@core/scss/vue/pages/page-pricing.scss";
</style>

<style scoped>
table {
  overflow: scroll;
}
#element-to-convert,
#element-to-convert td,
#element-to-convert th {
  font-size: 0.95em; /* Or use px, e.g. 12px */
}
.table-responsive .table,
.table-responsive .table th,
.table-responsive .table td {
  font-size: clamp(0.85rem, 2vw, 1.1rem);
  white-space: nowrap;
}

@media (max-width: 700px) {
  .table-responsive {
    overflow-x: auto;
  }
  .table-responsive .table {
    min-width: 400px;
  }
}

@media (max-width: 600px) {
  .hide-mobile {
    display: none;
  }
}
</style>
